export default "__VITE_ASSET__Px$xr9nd__"